var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse3, _ellipse4, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _g2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _ellipse5, _path42, _path43, _path44, _ellipse6, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSustainability = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 865.76 682.89"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M184.99 616.85v-70.4l172.47-11.88 266.14 27.88 96.31 13-24.66 55z",
  "data-primary": "true"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M184.99 616.85v-70.4l172.47-11.88 266.14 27.88 96.31 13-24.66 55z",
  opacity: 0.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M233.46 482.58s9.47-19.56 124 14.66l75 19.93 21.16 3.49s149.49-61.95 191.42-35.58l74.85 72.54-32 26.47-382.5-16.28-44.12 6.85-8.29-6Z",
  "data-primary": "true"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M233.46 482.58s9.47-19.56 124 14.66l75 19.93 21.16 3.49s149.49-61.95 191.42-35.58l74.85 72.54-32 26.47-382.5-16.28-44.12 6.85-8.29-6Z",
  opacity: 0.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M587 419.77s12.44 38.13 11.22 66.41c0 0 10.78 38.27 15.78 61.27l20.86 2.07-.4-33.46S610 437.45 600 415.45ZM539 433.45s-23 67-28 101l48 5s-9-89.47 0-108.74Z",
  "data-secondary": "true"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M539 433.45s-23 67-28 101l48 5s-9-89.47 0-108.74Z",
  opacity: 0.2
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M465 437.45s10 44 7 94l39 3v-3.88s-31.4-97.59-32.7-99.86ZM417 530.45h44.8s-3.82-62 1.18-89l-38 11 2.41 40.31S418 522.45 417 530.45",
  "data-secondary": "true"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 488.36,
  cy: 494.27,
  fill: "#fff",
  opacity: 0.3,
  rx: 6.33,
  ry: 17.5,
  transform: "rotate(-11.5 482.559 497.69)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M196 359.45s7 3 7 51c0 0-4 45.26-14 74.63l-21 36.37 23 37 30.09-6.61 5.91-99.11s-5.9-73.28-10.45-93.28Z",
  "data-secondary": "true"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M196 359.45s7 3 7 51c0 0-4 45.26-14 74.63l-21 36.37 23 37 30.09-6.61 5.91-99.11s-5.9-73.28-10.45-93.28Z",
  opacity: 0.2
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M253 416.45s-11 77.39-3 130.19l-49 8.81s11.85-83.54 46.93-151.77Z",
  "data-secondary": "true"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 233.46,
  cy: 462.56,
  fill: "#fff",
  opacity: 0.3,
  rx: 16.79,
  ry: 6.33,
  transform: "rotate(-81.82 233.45 462.56)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M836.68 289.1s-1.42 20.11-14.34 17a57 57 0 1 1-102.11-49.59 25.57 25.57 0 0 1-4.74-12.31 25 25 0 0 1 12.21 2.51 57 57 0 0 1 97.84 46.64c3.04-2.13 7.28-4.41 11.14-4.25",
  "data-primary": "true"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M836.68 289.1s-1.42 20.11-14.34 17a57 57 0 1 1-102.11-49.59 25.57 25.57 0 0 1-4.74-12.31 25 25 0 0 1 12.21 2.51 57 57 0 0 1 97.84 46.64c3.04-2.13 7.28-4.41 11.14-4.25",
  opacity: 0.3
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "m626.6 83.61-2 22.13-4.84 54.55-125.51 153.16-121.19 7-83.38-40.09-39.48-153-9-34.76 16.37-9.32s180.66-35.5 369.03.33",
  "data-primary": "true"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m626.6 83.61-2 22.13-4.84 54.55-125.51 153.16-121.19 7-83.38-40.09-39.48-153-9-34.76 16.37-9.32s180.66-35.5 369.03.33",
  opacity: 0.7
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M345 209.52s30.09 10.54 40.39 20.94a8.32 8.32 0 0 1 1.51 9.34c-1 2.26-.77 5.95 7.12 10 0 0 37.31 6.75 46.36 12.82a1.73 1.73 0 0 1-.56 3.14c-6.68 1.56-29.08 3.7-94.27-9-.04-.02 6.39-28.16-.55-47.24M496 230.45s-50.32 1-44.16-5c0 0 4.16-4 19.16-2 0 0 14.42.9 17.16-8.44a12.1 12.1 0 0 1 1.81-3.88 18.7 18.7 0 0 1 18.25-7.72S501 213.45 496 230.45M626.6 83.61l-2 22.13-14.12-1.59C588 96.85 525 121.45 525 121.45c-25 10-29 6-29 6-10-8 12.22-19 12.22-19 24.22-31-181.22-5-181.22-5 40 20.6 52.44 30.18 56 34.54a2.25 2.25 0 0 1-1.89 3.69c-13.92-.86-58.41-21.54-73.16-25.23-16-4-13 4-13 4 2 12-12.68 13.42-12.68 13.42l-32.1-6.53-9-34.76 16.37-9.32s180.69-35.48 369.06.35M532 177.21s-3-3.75 25-17.76c2-1 40.59-17.77 40.59-17.77h15.55l-23.06 31.9Z",
  opacity: 0.7
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "m739 303.45-22.89 3.73C695.2 416.91 633 382.45 633 382.45c-9 54-59 41-59 41-32 33-65.78 3.18-65.78 3.18 13.51 6.46 33 8.11 54.78-14.18 0 0 60-2 84-72 0 0 27-18 64-70a93.4 93.4 0 0 0 22.37 18.43Z",
  "data-primary": "true"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "m739 303.45-22.89 3.73C695.2 416.91 633 382.45 633 382.45c-9 54-59 41-59 41-32 33-65.78 3.18-65.78 3.18 13.51 6.46 33 8.11 54.78-14.18 0 0 60-2 84-72 0 0 27-18 64-70a93.4 93.4 0 0 0 22.37 18.43Z",
  opacity: 0.2
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M371 471.45c-74 37-79-37-79-37a84 84 0 0 1-20-2.91c-34-9.59-31-39.09-31-39.09-15-2-13-13-13-13 8-4 13 3 13 3a26.77 26.77 0 0 1 11-22c-5-3-4.8-10.34-4.8-10.34-45.79 47.67-95.62-22.43-95.62-22.43 7.26-1.68 20.42-5.74 25.42-14.23 0 0 69 47 123 8-.44.49-14.58 16.5-15.78 48.49 0 0-7.64-3.5-11.42 0 0 0-1.79 7.5 11.21 12.5-.01.01 5.99 77.01 86.99 89.01",
  "data-primary": "true"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M371 471.45c-74 37-79-37-79-37a84 84 0 0 1-20-2.91c-34-9.59-31-39.09-31-39.09-15-2-13-13-13-13 8-4 13 3 13 3a26.77 26.77 0 0 1 11-22c-5-3-4.8-10.34-4.8-10.34-45.79 47.67-95.62-22.43-95.62-22.43 7.26-1.68 20.42-5.74 25.42-14.23 0 0 69 47 123 8-.44.49-14.58 16.5-15.78 48.49 0 0-7.64-3.5-11.42 0 0 0-1.79 7.5 11.21 12.5-.01.01 5.99 77.01 86.99 89.01",
  opacity: 0.2
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M804 182.45s-5-144-130-124c0 0-19.65 3.19-39.24 18.18A14.41 14.41 0 0 0 619.34 71c1.74 6.54 4.44 10.37 7.27 12.57-15.38 14.79-29 37.92-30.63 73.84 0 0-75-6-100 73 0 0-43 29-42 71 0 0-49-48-118-15 0 0 49-98-52-141 0 0-5-94-106-93 0 0-68 2-103 103 0 0-71 45-29 107 0 0 14 25 55 27 0 0 8.15 42.39 45.57 39.19 0 0 2-.27 5-1 7.29-1.6 20.45-5.66 25.45-14.15 0 0 69 47 123 8-.44.49-14.58 16.5-15.78 48.49 0 0-7.64-3.5-11.42 0 0 0-1.79 7.5 11.21 12.5 0 0 6 77 87 89 0 0 12.4 15.62 31.91 21.32a42.83 42.83 0 0 0 52.84-27.41 69.3 69.3 0 0 0 3.24-15.9s27-5 30-38a58.4 58.4 0 0 0 19.22 15.18c13.51 6.46 33 8.11 54.78-14.18 0 0 60-2 84-72 0 0 27-18 64-70a93.4 93.4 0 0 0 22.37 18.43c20.82 12.25 53.54 19.48 86.63-21.43 0 0 30-47-16-85",
  "data-primary": "true"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m682.71 547.6-1.69 10-37-6.5-9.13-1.6S636 449.45 621 398.45c0 0-12-47-34-61l2-5 .1.06.1.06c2.2 1.32 19.92 12 22.76 14.85-.21-.58-7-19.08-10-25l9-2s17 34 21 47c0 0 15-23 20-27l3.54 2.51S632 376.45 642 393.45c0 0 14 36 23 73 0 0 13.43 49.3 17.71 81.15",
  "data-secondary": "true"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "m682.71 547.6-1.69 10-37-6.5a710 710 0 0 0-6-103.67c-9-65-18-82-18-82-5.66-16.05-28.26-31.21-30.77-32.86 2.2 1.32 19.92 12 22.76 14.85-.21-.58-7-19.08-10-25l9-2s17 34 21 47c0 0 15-23 20-27l3.54 2.51S632 376.45 642 393.45c0 0 14 36 23 73 0 0 13.43 49.3 17.71 81.15",
  opacity: 0.2
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m614 547.45-36-6-10-1.66v-74.34c-7-61-15-69-15-69-9-12-40-23.5-40-23.5v-4.5c16 6 34 13 34 13l-3.36-15H554l26 66c18 43 34 115 34 115",
  "data-secondary": "true"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M578 541.47v-56c-3-58-17-88-17-88-2-8-48-29-48-29 16 6 34 13 34 13l-3.36-15H554l26 66c18 43 34 115 34 115Z",
  opacity: 0.2
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M387 532.45c-2.31 0-6.18.21-10.76.55-15.24 1.09-38.24 3.45-38.24 3.45 6-22 27-88 27-88l-13-34 11-1 8 21.21a97 97 0 0 1 3.61-11.87c4.45-12.27 10.75-25.16 10.75-25.16l8.64 2.82c-17 41-7 132-7 132M293 542.45l-51.26 5c-4.37-38.16 21.4-97 30.31-115.91a84 84 0 0 0 20 2.91c-8.05 54 .95 108 .95 108",
  "data-secondary": "true"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "m293 542.45-51.26 5c-4.37-38.16 21.4-97 30.31-115.91a84 84 0 0 0 20 2.91c-8.05 54 .95 108 .95 108",
  opacity: 0.2
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 659.36,
  cy: 502.27,
  fill: "#fff",
  opacity: 0.3,
  rx: 6.33,
  ry: 17.5,
  transform: "rotate(-11.5 653.123 507.329)"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 357.46,
  cy: 501.56,
  fill: "#fff",
  opacity: 0.3,
  rx: 16.79,
  ry: 6.33,
  transform: "rotate(-81.82 357.448 501.562)"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M387 532.45c-2.31 0-6.18.21-10.76.55-4.85-31.22-3-83.27-1.63-110.21 4.45-12.27 10.75-25.16 10.75-25.16l8.64 2.82c-17 41-7 132-7 132",
  opacity: 0.2
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M513 534.66s65.27 8.54 101 12.79c0 0 5-8-11.48-8 0 0 2.48-12-10.52-3 0 0 3-14-12-9 0 0 4-11-11-6 0 0-1-19-15-4 0 0-8-19-14 3 0 0-12-15-14 10 0 0-12-11.58-13 4.21M328 537.45s-44 7.39-78 9.19c0 0-5.46-23.19 12.77-9.19 0 0 1.23-23 13.23-9 0 0 5.42-22 14.71-4.52 0 0 12.29-16.48 14.29 4.52 0 0 12-4 12 6 0 0 6-6 11 3",
  "data-primary": "true"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M513 534.66s66.27 8.54 101 12.79c0 0 5-8-11.48-8 0 0 2.48-12-10.52-3 0 0 3-14-12-9 0 0 4-11-11-6 0 0-1-19-15-4 0 0-8-19-14 3 0 0-12-15-14 10 0 0-12-11.58-13 4.21M328 537.45s-44 7.39-78 9.19c0 0-5.46-23.19 12.77-9.19 0 0 1.23-23 13.23-9 0 0 5.42-22 14.71-4.52 0 0 12.29-16.48 14.29 4.52 0 0 12-4 12 6 0 0 6-6 11 3"
}))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M164 146.45s-3.46 19.87-16 15.44a57 57 0 1 1-96.54-59.72A25.6 25.6 0 0 1 48 89.45a25 25 0 0 1 11.9 3.74 57 57 0 0 1 92.59 56.34c3.22-1.79 7.67-3.63 11.51-3.08",
  "data-primary": "true"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M164 146.45s-3.46 19.87-16 15.44a57 57 0 1 1-96.54-59.72A25.6 25.6 0 0 1 48 89.45a25 25 0 0 1 11.9 3.74 57 57 0 0 1 92.59 56.34c3.22-1.79 7.67-3.63 11.51-3.08",
  opacity: 0.3
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M825.41 118s7.93 18.55-5 21.67a57 57 0 1 1-113.48 2.58 25.54 25.54 0 0 1-9.85-8.77 25.06 25.06 0 0 1 12-3.36 57 57 0 0 1 108.33-3.26c1.77-3.24 4.5-7.21 8-8.86",
  "data-primary": "true"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M825.41 118s7.93 18.55-5 21.67a57 57 0 1 1-113.48 2.58 25.54 25.54 0 0 1-9.85-8.77 25.06 25.06 0 0 1 12-3.36 57 57 0 0 1 108.33-3.26c1.77-3.24 4.5-7.21 8-8.86",
  opacity: 0.3
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M298 168.45s-.17-19 16.42-16c-.02 0 3.58 15-16.42 16M425 287.45s6.64-8 17.32-7c0 0-2.32 11.27-9.82 13.63ZM255 308.45s1-21 17-16c0 0 4 13-17 16M445 420.45s1-21 17-16c0 0 4 13-17 16M538.62 394.37s20.74-3.44 19.22 13.25c0 0-11.84 6.65-19.22-13.25M631.37 327s7.2 19.75-9.49 21.33c0-.01-8.71-10.45 9.49-21.33M45 209.45s-15.8-1-15.9-16c-.02 0 16.9-4 15.9 16M123 278.45s-4 14 16 15c0 0 2-17-16-15M540 237.45s-11-10 4-24c0 0 11 11-4 24M648.63 188.86s-14 5-19.29-14.82c0-.04 14.88-4.53 19.29 14.82M711.63 107.86s-14 5-19.29-14.82c0-.04 14.88-4.53 19.29 14.82",
  "data-primary": "true"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M255 308.45s1-21 17-16c0 0 4 13-17 16M445 420.45s1-21 17-16c0 0 4 13-17 16M538.62 394.37s20.74-3.44 19.22 13.25c0 0-11.84 6.65-19.22-13.25M631.37 327s7.2 19.75-9.49 21.33c0-.01-8.71-10.45 9.49-21.33M45 209.45s-15.8-1-15.9-16c-.02 0 16.9-4 15.9 16M123 278.45s-4 14 16 15c0 0 2-17-16-15M540 237.45s-11-10 4-24c0 0 11 11-4 24M648.63 188.86s-14 5-19.29-14.82c0-.04 14.88-4.53 19.29 14.82M711.63 107.86s-14 5-19.29-14.82c0-.04 14.88-4.53 19.29 14.82"
}))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M305 193.45c-7.47 1.25-11.84 4.43-14.07 6.66A53.45 53.45 0 0 0 203.44 188c-7.67-6.45-14.46-6.13-14.46-6.13 1 9 4.75 12.92 8.1 14.62a55.4 55.4 0 0 0-8.1 28.95c0 30.38 24.18 55 54 55s54-24.62 54-55a56.2 56.2 0 0 0-2.09-15.17C308.51 204 305 193.45 305 193.45",
  "data-primary": "true"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M305 193.45c-7.47 1.25-11.84 4.43-14.07 6.66A53.45 53.45 0 0 0 203.44 188c-7.67-6.45-14.46-6.13-14.46-6.13 1 9 4.75 12.92 8.1 14.62a55.4 55.4 0 0 0-8.1 28.95c0 30.38 24.18 55 54 55s54-24.62 54-55a56.2 56.2 0 0 0-2.09-15.17C308.51 204 305 193.45 305 193.45",
  opacity: 0.3
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m98.48 231 5-7 23 23 3-30s4 22 6 37l26.5 32.5 29-134h11.15l1.85 92 39-21 7 7-43 33s-12 49-13 80c0 0-5 49-6 111 0 0 2 94 14 130l-93 13s13-16 20-77c0 0 8-158 19-187l-19-64Z",
  "data-secondary": "true"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "m673.63 630.45-11.43-10.54c-157.78-10.55-369.2-1.19-369.2-1.19 0-9.72-20-8.27-20-8.27-2-24-20-8.9-20-8.9-2-25.91-24-14.1-24-14.1 4-30-21-13-21-13-9-37-30.87-7.9-30.87-7.9-21.87-22.9-25.55 8.69-25.55 8.69C124.15 549 122 590.45 122 590.45c-37-16-23.5 18.61-23.5 18.61C73 603.67 86 630.45 86 630.45Z",
  "data-primary": "true"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "m673.63 630.45-11.43-10.54c-157.78-10.55-369.2-1.19-369.2-1.19 0-9.72-20-8.27-20-8.27-2-24-20-8.9-20-8.9-2-25.91-24-14.1-24-14.1 4-30-21-13-21-13-9-37-30.87-7.9-30.87-7.9-21.87-22.9-25.55 8.69-25.55 8.69C124.15 549 122 590.45 122 590.45c-37-16-23.5 18.61-23.5 18.61C73 603.67 86 630.45 86 630.45Z",
  opacity: 0.2
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m673 244.45-18-64h11.35L715.46 286l58.88-60.51 5.85 4.6L750 268.45s-16 55-20 65c0 0 15 73 14 123l6 70s5 69 41 104H655s25.29-21.82 33.65-135.91c0 0 8.35-118.09-18.65-231.09l-40-18-42 14 32-18-35.07-16 5.07-8Z",
  "data-secondary": "true"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m207 589.45-10.71-4.2s4.71-17.8 14.71-22.8l7.17 7.53S211 575.45 207 589.45"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M246.37 575.21a90 90 0 0 1-2.39 9.24c-35-7-47.71-44.93-47.71-44.93a86 86 0 0 1 10.73-3.38 56.6 56.6 0 0 1 19.52-1.56c8.35.93 12.47 3.87 12.47 3.87a16.54 16.54 0 0 1 6.84 8.12c3.6 8.57 2.22 20.48.54 28.64",
  "data-primary": "true"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 217.15,
  cy: 555.33,
  fill: "#fff",
  opacity: 0.5,
  rx: 6.2,
  ry: 8,
  transform: "rotate(-36.24 217.18 555.381)"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M246.37 575.21a7.5 7.5 0 0 1-1.89.24c-5.8 0-10.5-6.49-10.5-14.5s4.7-14.5 10.5-14.5a7.5 7.5 0 0 1 1.34.12c3.61 8.57 2.23 20.48.55 28.64M227 536c0 2.49-4.48 4.5-10 4.5s-9.77-1.91-10-4.31a56.6 56.6 0 0 1 19.52-1.56A2.4 2.4 0 0 1 227 536",
  opacity: 0.5
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M168 581.5v-16l6.25-1.72s1.75 5.7 3.75 14.7c0-.03-3 1.06-10 3.02"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6c9b1",
  d: "M185 557.45c-7 16-34 10-34 10 1.47-11.28 4.14-17.74 6.49-21.41A10.45 10.45 0 0 1 170 541.8c.29.11.59.24.87.38 4.84 2.2 8.78 6.92 11.26 10.53a45 45 0 0 1 2.87 4.74",
  "data-primary": "true"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 160.48,
  cy: 556.95,
  fill: "#fff",
  opacity: 0.5,
  rx: 4.5,
  ry: 5.5
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M182.11 552.71a7.22 7.22 0 0 1-5.63 2.74 7.76 7.76 0 0 1-7.5-8 8.22 8.22 0 0 1 1.87-5.27c4.84 2.2 8.78 6.92 11.26 10.53",
  opacity: 0.5
})));
export default SvgSustainability;